<div class="content">
  <span class="title">Olá! Seja bem-vindo.</span>
  <img src="assets/images/logo-home-welcome.svg" alt="logo">
</div>
